import React, { useState } from 'react';
import { SiWhatsapp, SiInstagram, SiTiktok } from "react-icons/si";
import { FaCommentDots } from "react-icons/fa6";
import { TbPhone } from "react-icons/tb";

export default function Calls() {
    const [isCalls, setIsCalls] = useState(false);

    const handleCalls = () => {
        setIsCalls(!isCalls);
    };

    return (
        <div className={`fixed bottom-6 right-6 sm:bottom-14 sm:right-14 z-[99] flex flex-col-reverse items-center gap-2 transition-all `}>
            <button className='bg-black w-16 h-16 md:w-24 md:h-24 rounded-full flex items-center justify-center' onClick={handleCalls}>
                <FaCommentDots className='w-8 h-8 md:w-10 md:h-10 fill-[#FCFC00] breathe' />
            </button>
            <a href="https://www.instagram.com/bbyshinn_towing/" target="_blank" rel="noopener noreferrer" className={`bg-black w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-transform duration-300 -z-10 ${isCalls ? 'translate-y-0 visible' : 'translate-y-16 md:translate-y-24'}`}>
                <button >
                    <SiInstagram className='w-6 h-6 md:w-8 md:h-8 fill-[#FCFC00]' />
                </button>
            </a>
            <a href="//wa.me/+6282288349889" target="_blank" rel="noopener noreferrer" className={`bg-black w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-transform duration-300 -z-10 ${isCalls ? 'translate-y-0 visible' : 'translate-y-24 md:translate-y-40'}`}>
                <button >
                    <SiWhatsapp className='w-6 h-6 md:w-8 md:h-8 fill-[#FCFC00]' />
                </button>
            </a>
            <a href="https://www.tiktok.com/@bbyshinn_towing?_t=8pUepO664Gq&_r=1" target="_blank" rel="noopener noreferrer" className={`bg-black w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-transform duration-300 -z-10 ${isCalls ? 'translate-y-0 visible' : 'translate-y-36 md:translate-y-56'}`}>
                <button >
                    <SiTiktok className='w-6 h-6 md:w-8 md:h-8 fill-[#FCFC00]' />
                </button>
            </a>
            <a href="tel:082288349889" target="_blank" rel="noopener noreferrer" className={`bg-black w-10 h-10 md:w-16 md:h-16 rounded-full flex items-center justify-center transition-transform duration-300 -z-10 ${isCalls ? 'translate-y-0 visible' : 'translate-y-52 md:translate-y-72'}`}>
                <button >
                    <TbPhone className='w-6 h-6 md:w-8 md:h-8 fill-[#FCFC00]' />
                </button>
            </a>

        </div>
    );
}
